import moment from "moment";
import { dayMapper } from "../../helpers/tools";

export const adaptAPResumen = (data) => {

    const { diaConexionMagistral,
        diaConexionEstandar,
        laboratorioAdjunto,
        laboratorio,
        fechaColocacionCateter,
        indicacionRI,
        proteinasTotales,
        lipidosTotales,
        caloriasTotales,
        ...apData
    } = data;

    return {
        ...apData,
        laboratorioAdjunto: {
            contentType: laboratorioAdjunto?.contentType,
            archivo: laboratorioAdjunto?.archivo,
            extension: laboratorioAdjunto?.extension,
            titulo: laboratorioAdjunto?.titulo,
        },
        laboratorioAP: laboratorio,
        proteinasTotalesAP: proteinasTotales,
        lipidosTotalesAP: lipidosTotales,
        caloriasTotalesAP: caloriasTotales,
        fechaColocacionCateter: moment(fechaColocacionCateter).format('DD/MM/YYYY'),
        diasConexionSemanaMagistralAP: diaConexionMagistral.map(day => dayMapper[day]),
        diasConexionSemanaAP: diaConexionEstandar.map(day => dayMapper[day]),
        nombreInsumoAP: indicacionRI?.idInsumoNavigation?.descripcion,
        cantidadDiariaAP: indicacionRI?.cantidadDiaria,
    }
}